import { CLASSES } from "@/scripts/helpers/constants";
import Cookies from "js-cookie";

export default () => {
  const hiddenBaner = () => {
    const banner = $(".banner-marketing"),
          close = $(".banner-close");

    if (banner.length) {
      close.on("click", function (e) {
        e.preventDefault();
        banner.addClass(CLASSES.IS_HIDDEN);
      });
    };
  };

  hiddenBaner();
};

export const setCookieApi = () => {
  let { hostname } = window;

  if (hostname === "undefined") {
    hostname = "signnow.com";
  }

  $(".banner-close").click(function(e) {
    e.preventDefault();
    
    Cookies.set("api_banner", "true", { 
      expires: 365, 
      domain: hostname 
    });

    $(".banner-marketing__v5").addClass(CLASSES.IS_HIDDEN);
  });
};
